import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Divider from "@mui/material/Divider";
import { NavigationTree } from "./NavigationTree.tsx";
import { useTheme } from "@mui/material/styles";
import { DrawerHeader } from "./styled/DrawerHeader.tsx";
import { drawerWidth } from "../data/styleConstants.ts";

type MenuDrawerProps = {
  handleDrawerClose: () => void;
  open: boolean;
};
export const MenuDrawer = ({ handleDrawerClose, open }: MenuDrawerProps) => {
  const theme = useTheme();
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <NavigationTree />
    </Drawer>
  );
};
